import { useTranslation } from "react-i18next";

import "components/Recalls/components/RecallsModal/components/NoData/NoData.scss";

export type NoDataProps = {
  hasData: boolean;
};

export const NoData = ({ hasData }: NoDataProps) => {
  const { t } = useTranslation();

  if (hasData) return null;

  return <div className="NoData">{t("v8_recalls_not_found", "Recalls Not Found")}</div>;
};
